/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var FuelType;
(function (FuelType) {
    FuelType["Gasoline"] = "Gasoline";
    FuelType["Electric"] = "Electric";
    FuelType["Diesel"] = "Diesel";
    FuelType["Hybrid"] = "Hybrid";
})(FuelType || (FuelType = {}));
export function FuelTypeFromJSON(json) {
    return FuelTypeFromJSONTyped(json, false);
}
export function FuelTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FuelTypeToJSON(value) {
    return value;
}
